import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { accountManagersFeatureKey, reducer } from './account-managers.reducer';
import { AccountManagersEffects } from './effects/account-managers.effects';
import { JobRecommendationEffects } from './effects/job-recommendations.effects';
import { WorkforceNotesEffects } from './effects/workforce-notes.effects';
import { EnvironmentProviders } from '@angular/core';

export const provideAccountManagersStore = (): EnvironmentProviders[] => [
    provideState(accountManagersFeatureKey, reducer),
    provideEffects([AccountManagersEffects, WorkforceNotesEffects, JobRecommendationEffects])
];
